/**
 * Fantasy Console 0 - Toast Component
 */

import { Toast as ToastType } from '../../types'
import { CloseIcon } from '../shared/icons'
import styles from './Toast.module.css'

interface ToastProps {
  toast: ToastType
  onDismiss: () => void
}

export function Toast({ toast, onDismiss }: ToastProps) {
  const typeStyles = {
    success: styles.success,
    error: styles.error,
    warning: styles.warning,
    info: styles.info,
  }

  return (
    <div className={`${styles.toast} ${typeStyles[toast.type]}`} role='alert'>
      <ToastIcon type={toast.type} />
      <span className={styles.message}>{toast.message}</span>
      <button
        className={styles.dismiss}
        onClick={onDismiss}
        aria-label='Dismiss notification'
      >
        <CloseIcon size={12} />
      </button>
    </div>
  )
}

function ToastIcon({ type }: { type: ToastType['type'] }) {
  switch (type) {
    case 'success':
      return (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='currentColor'>
          <path d='M8 1a7 7 0 100 14A7 7 0 008 1zm3.7 5.3l-4 4a1 1 0 01-1.4 0l-2-2a1 1 0 011.4-1.4L7 8.2l3.3-3.3a1 1 0 011.4 1.4z' />
        </svg>
      )
    case 'error':
      return (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='currentColor'>
          <path d='M8 1a7 7 0 100 14A7 7 0 008 1zM7 4h2v5H7V4zm0 6h2v2H7v-2z' />
        </svg>
      )
    case 'warning':
      return (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='currentColor'>
          <path d='M8 1L1 14h14L8 1zM7 6h2v4H7V6zm0 5h2v2H7v-2z' />
        </svg>
      )
    case 'info':
    default:
      return (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='currentColor'>
          <path d='M8 1a7 7 0 100 14A7 7 0 008 1zM7 4h2v2H7V4zm0 3h2v5H7V7z' />
        </svg>
      )
  }
}
